import '../../sass/blocks/find-us.scss';

const mapStyle = [
    {
        "featureType": "poi.attraction",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.government",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];

(() => {
    const $findUs = document.querySelectorAll('.find-us');

    if (!$findUs) return;

    $findUs.forEach($findUs => {
        const $map = $findUs.querySelector('.find-us__map-inner');

        const initMap = () => {
            if (!$map || !google) return;

            const { mapLat, mapLng } = $map.dataset;

            if (!mapLat || !mapLng) return;

            const mapLatLng = { lat: parseFloat(mapLat), lng: parseFloat(mapLng) };

            const map = new google.maps.Map($map, {
                zoom: 15,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                center: mapLatLng,
                styles: mapStyle
            });

            new google.maps.Marker({
                position: mapLatLng,
                map,
                draggable: false,
                icon: {
                    path: "m7 40.2 14.6 14.6c.5.5 1.2.8 1.8.8.7 0 1.3-.3 1.8-.8L40 40.2c9-9.1 9-23.9 0-32.9C35.6 2.9 29.8.5 23.5.5S11.4 2.9 7 7.3.2 17.5.2 23.8s2.4 12 6.8 16.4z",
                    fillColor: '#203864',
                    fillOpacity: 1,
                    size: new google.maps.Size(47, 56),
                    anchor: new google.maps.Point(23.5, 56),
                    strokeWeight: 0,
                    scale: 1
                }
            });

            new google.maps.Marker({
                position: mapLatLng,
                map,
                draggable: false,
                icon: {
                    path: "M23.5 39.1c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm0-29c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14z",
                    fillColor: '#fff',
                    fillOpacity: 0.5,
                    size: new google.maps.Size(47, 56),
                    anchor: new google.maps.Point(23.5, 56),
                    strokeWeight: 0,
                    scale: 1
                }
            });

            new google.maps.Marker({
                position: mapLatLng,
                map,
                draggable: false,
                icon: {
                    path: "M19.5,24.1a4,4 0 1,0 8,0a4,4 0 1,0 -8,0",
                    fillColor: '#fff',
                    fillOpacity: 1,
                    size: new google.maps.Size(47, 56),
                    anchor: new google.maps.Point(23.5, 56),
                    strokeWeight: 0,
                    scale: 1
                }
            });

            const transitLayer = new google.maps.TransitLayer();
          
            transitLayer.setMap(map);
        };

        window.addEventListener('load', () => {
            initMap();
        });
    })
})();
